import { useEffect } from 'react';

import { createForceLogoutWatcher } from '@ngsos/portal-core';
import { emsBaseUrl } from '@ngsos/portal-core/api/clients';

import { getAccessToken } from '@/api/auth';
import { useNavigateToLogout } from '@/app/auth/interactiveLogout';

export function ForceLogoutWatcher() {
  const navigateToLogout = useNavigateToLogout();

  useEffect(() => {
    const watcher = createForceLogoutWatcher({
      emsServerUrl: emsBaseUrl(),
      accessTokenFactory: async () => (await getAccessToken()) ?? '',
      onForceLogout: navigateToLogout,
      onError: (message, error) => console.error(`[SLO] ${message}`, error),
    });
    watcher.start();

    return () => watcher.dispose();
  }, [navigateToLogout]);

  return null;
}
